import React, { lazy } from 'react'
import Container from '../modals/common/container'

const InterestMarketingModal = lazy(() =>
  import('../modals/InterestMarketingModal'),
)
const ShoppingHowItWorks = lazy(() =>
  import('../modals/settings/shopping-how-it-works'),
)
const DARHistory = lazy(() =>
  import('../modals/dataPrivacy/data-access/DARHistory'),
)
const DataCorrection = lazy(() =>
  import('../modals/dataPrivacy/data-correction'),
)
const DataDeletion = lazy(() =>
  import('../modals/dataPrivacy/data-deletion/introduction'),
)
const PrivacyRights = lazy(() => import('../modals/privacyhub/privacy-rights'))

const PersonalizeShopping = lazy(() =>
  import('../modals/settings/personalize-shopping'),
)

function selectDynamicComponent(componentName) {
  let DynamicComponent
  switch (componentName) {
    case 'interestMarketingModal':
      DynamicComponent = InterestMarketingModal
      break
    case 'shoppingHowItWorks':
      DynamicComponent = ShoppingHowItWorks
      break
    case 'dataRequestHistory':
      DynamicComponent = DARHistory
      break
    case 'dataCorrection':
      DynamicComponent = DataCorrection
      break
    case 'dataDeletion':
      DynamicComponent = DataDeletion
      break
    case 'privacyRights':
      DynamicComponent = PrivacyRights
      break
    case 'personalizeShopping':
      DynamicComponent = PersonalizeShopping
      break
    default:
      DynamicComponent = null
  }
  return DynamicComponent
}

const CreateComponent = (props) => {
  const { slides = [], position = 0, name } = props
  const DynamicComponent = selectDynamicComponent(name)

  if (!DynamicComponent && !slides.length) {
    return null
  }

  return slides.length ? (
    <Container position={position}>
      {slides.map((Slide, key) => (
        <Slide key={key} {...props} />
      ))}
    </Container>
  ) : (
    <DynamicComponent {...props} />
  )
}

export default CreateComponent
